import moment from 'moment';
import {
  useCurrentUserForPhoneScreeningScheduled,
  useProfessionalScreeningsForPhoneScreeningScheduled,
  useRecruitersForPhoneScreeningScheduled,
} from './graphql';
import { useCancelScreening } from './mutations';

export const usePhoneScreeningScheduledData = () => {
  const { currentUser, isLoading } = useCurrentUserForPhoneScreeningScheduled();
  const { professionalScreening, isLoading: isLoadingScreenings } =
    useProfessionalScreeningsForPhoneScreeningScheduled();
  const isEnableRescreeningAutomation = currentUser?.professional?.enable_rescreening_automation;

  const { recruiter, isLoading: isLoadingRecruiter } = useRecruitersForPhoneScreeningScheduled(
    !isEnableRescreeningAutomation ? currentUser?.professional?.screening_recruiter_id : null,
  );

  const { cancelScreeningLegacy, cancelScreening, isPending } = useCancelScreening(
    professionalScreening?.id,
  );

  const screenerAccount = isEnableRescreeningAutomation
    ? professionalScreening?.screener_account
    : recruiter?.account;

  const isLoadingAccount = isEnableRescreeningAutomation ? isLoadingScreenings : isLoadingRecruiter;

  const dateTimeData = isEnableRescreeningAutomation
    ? professionalScreening?.scheduled_time
    : currentUser?.professional?.phone_screen_date_and_time;

  const date = moment(dateTimeData).format('dddd MM/DD/YY');
  const time = `${moment(dateTimeData).format('hh:mm a')} (30 min)`;

  const recruiterMessage = `${
    screenerAccount?.first_name ?? 'Your recruiter'
  } will call you at the scheduled time`;

  return {
    isLoading: isLoading || isLoadingScreenings || isLoadingAccount,
    isMutationPending: isPending,
    date,
    time,
    recruiterMessage,
    cancelScreening: isEnableRescreeningAutomation ? cancelScreening : cancelScreeningLegacy,
  };
};
